import TopSection from "../../LT/TopSection";

const AdminPage = () => {
    return (
        <div>
            <TopSection
                labelList={[
                            { title: "Home", path: "/dashboard" },
                    { title: "Admin" },
                ]}
                tabTitle="Admin"
            />
        </div>
    )
}

export default AdminPage;